<template>
  <div class="container">
    <BaseHeader :title="$t('views.seller.links.text_1125')">
      <BaseButton
        variant="primary"
        v-b-modal.links-new
        @click="dataEdit = null"
        class="btn-adicionar"
        :disabled="!product_id"
        >
        {{ $t("views.seller.links.text_1129") }}
      </BaseButton>
    </BaseHeader>
    <b-tabs
      class="mt-5 mb-5"
      content-class="mt-3"
      nav-class="TabHeader"
      active-nav-item-class="TabHeader--active"
      @activate-tab="tabSelect"
    >
      <b-tab
        :title="$t('views.seller.links.text_1607')"
        :active="!comingAffiliate"
      >

         <template #title>
         {{$t('views.seller.links.text_1607')}}
          <span
            v-if="isValidateAccount" 
            id="links-alert-vendedor"
            class="tag-status" 
            :class="'in_progress'"
          >
           {{ $t('views.seller.my_account.status.' + 'in_progress') }}
          </span>
          <b-tooltip
            v-if="isValidateAccount"
            target="links-alert-vendedor"
            title="Para começar a vender acesse ‘Minha Conta’ e finalize seu cadastro."
          />
        </template>
    
        <b-container class="mt-1 p-5 wrapper container-item">
          <div class="d-flex justify-content-center" v-if="loading">
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <b-row v-if="!loading">
            <b-col>
              <h6 class="mb-3">{{ $t("views.seller.links.text_1126") }}</h6>
              <b-form-group label="">
                <div id="product-select">
                  <multiselect
                    v-model="product_id"
                    :placeholder="$t('views.seller.links.text_1127')"
                    label="name"
                    :name="`link-${productsSeller.id}`"
                    track-by="id"
                    :options="filterBy(productsSeller)"
                    :multiple="false"
                    :taggable="false"
                    ><span slot="noResult">{{
                      $t("views.seller.links.text_1128")
                    }}</span>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                        <span class="option__desc" v-if="props.option.status !== 'APPROVED'"> (Produto indisponível - em análise)</span>
                        <span class="option__desc" v-else-if="isProductLinkLocked(props.option)"> (Finalize seu cadastro em ‘Minha Conta’)</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
                <b-tooltip
                  v-if="isValidateAccount"
                  target="product-select"
                  title="Para começar a vender acesse ‘Minha Conta’ e finalize seu cadastro."
                />
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="product_id">
            <div class="d-flex justify-content-center" v-if="loading">
              <b-spinner label="Loading..."></b-spinner>
            </div>
            <b-row class="mt-4">
              <b-col cols="12" md="6">
                <b-form-group :label="$t('views.seller.links.text_1130')">
                  <a
                    v-if="salesPage"
                    :href="salesPage"
                    target="_blank"
                    class="link"
                    :class="{ carregando: load }"
                    >{{ cutText(salesPage) }}</a
                  >
                  <p v-if="!salesPage" class="p-editado">
                    {{ $t("views.seller.links.text_1131") }}
                  </p>
                  <span
                    @click="copyAddress(salesPage)"
                    class="btn p-2"
                    v-if="!load"
                  >
                    <img
                      src="@/assets/img/icons/copy.svg"
                      class="copy-link"
                      v-if="salesPage"
                    />
                  </span>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Link atual do checkout">
                  <a
                    :href="checkoutUrl(product, null, false, 'legacy')"
                    target="_blank"
                    class="link"
                    :class="{ carregando: load }"
                    >{{ cutText(checkoutUrl(product, null, false, 'legacy')) }}</a
                  >
                  <span
                    v-if="!load"
                    @click="copyAddress(checkoutUrl(product, null, false, 'legacy'))"
                    class="btn p-2"
                  >
                    <img src="@/assets/img/icons/copy.svg" class="copy-link"
                  /></span>
                </b-form-group>
              </b-col>

              <b-col cols="12" v-if="checkoutUrl(product, null, false, 'tokenized')">
                <b-form-group label="Novo link recomendado do checkout">
                  <a
                    :href="checkoutUrl(product, null, false, 'tokenized')"
                    target="_blank"
                    class="link"
                    :class="{ carregando: load }"
                    >{{ cutText(checkoutUrl(product, null, false, 'tokenized'), 100) }}</a
                  >
                  <span
                    v-if="!load"
                    @click="copyAddress(checkoutUrl(product, null, false, 'tokenized'))"
                    class="btn p-2"
                  >
                    <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                  </span>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group :label="$t('views.seller.links.text_1132')">
                  <a
                    data-anima="bottom"
                    v-if="link_afiliado == '---'"
                    href="#"
                    class="link"
                    @click.prevent="affiliateLink"
                    :class="{ carregando: load }"
                    >{{ $t("views.seller.links.text_1133") }}</a
                  >
                  <a
                    data-anima="bottom"
                    v-if="link_afiliado != '---'"
                    :href="link_afiliado"
                    target="_blank"
                    class="link"
                    :class="{ carregando: load }"
                    >{{ cutText(link_afiliado, 100) }}</a
                  >
                  <span
                    @click="copyAddress(link_afiliado)"
                    class="btn p-2"
                    v-if="!load && link_afiliado != '---'"
                  >
                    <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="my-2 outros">
              <b-col>
                <h6 class="outros-links">
                  {{ $t("views.seller.links.text_1609") }}
                </h6>
              </b-col>
            </b-row>
            <b-row class="mb-4" v-if="links.length >= 1 && !isMobile">
              <b-col cols="12" md="4" class="sub-titulo">
                {{ $t("views.seller.links.text_1610") }}
              </b-col>
              <b-col cols="12" md="8" class="sub-titulo"> Links disponíveis </b-col>
            </b-row>
            <template v-for="item in offers">
              <b-row :key="item.id" class="link-extra link-card">
                <b-col cols="12" md="4" class="titulo-link" :title="item.name">
                  {{ cutText(item.name, 65) }}
                </b-col>
                <b-col cols="12" md="8">
                  <div class="link-variants">
                    <div class="link-variant">
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Link atual</span>
                        <span class="link-variant__badge">Descontinuado</span>
                      </div>
                      <div class="link-field" :class="{ carregando: load }">
                        <a
                          :href="checkoutUrl(product, item.hash, false, 'legacy')"
                          :title="checkoutUrl(product, item.hash, false, 'legacy')"
                          target="_blank"
                          class="link-field__value"
                        >{{ displayUrl(checkoutUrl(product, item.hash, false, 'legacy')) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button"
                          @click="copyAddress(checkoutUrl(product, item.hash, false, 'legacy'))"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                    <div
                      v-if="checkoutUrl(product, item.hash, false, 'tokenized')"
                      class="link-variant link-variant--recommended"
                    >
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Novo link recomendado</span>
                        <span class="link-variant__badge link-variant__badge--recommended">Recomendado</span>
                      </div>
                      <div class="link-field">
                        <a
                          :href="checkoutUrl(product, item.hash, false, 'tokenized')"
                          :title="checkoutUrl(product, item.hash, false, 'tokenized')"
                          target="_blank"
                          class="link-field__value"
                        >{{ displayUrl(checkoutUrl(product, item.hash, false, 'tokenized')) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button link-copy-button--recommended"
                          @click="copyAddress(checkoutUrl(product, item.hash, false, 'tokenized'))"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </template>
            <b-row class="my-2 outros">
              <b-col>
                <h6 class="outros-links">
                  {{ $t("views.seller.links.text_1611") }}
                </h6>
              </b-col>
            </b-row>
            <b-row class="mb-4" v-if="links.length >= 1 && !isMobile">
              <b-col cols="12" md="4" class="sub-titulo">
                {{ $t("views.seller.links.text_1612") }}
              </b-col>
              <b-col cols="12" md="8" class="sub-titulo"> Links disponíveis </b-col>
            </b-row>
            <template v-for="item in links">
              <b-row
                v-if="item.name != 'MAIN'"
                :key="item.id"
                class="link-extra link-card"
              >
                <b-col cols="12" md="4" class="titulo-link">
                  <div>
                    {{ cutText(item.name, 60) }}
                    <img
                      v-show="item.offer_select === null"
                      src="@/assets/img/icons/info-prod-reprovado.svg"
                      :title="item.alert_text"
                      class="order-bump-alert"
                    />
                    <img
                      v-show="item.is_alert && item.alert_type === 'warning' && item.offer_select !== null"
                      src="@/assets/img/icons/notify_warning.svg"
                      :title="item.alert_text"
                      class="order-bump-alert"
                    />
                    <img
                      v-show="item.is_alert && item.alert_type === 'danger' && item.offer_select !== null"
                      src="@/assets/img/icons/info-prod-reprovado.svg"
                      :title="item.alert_text"
                      class="order-bump-alert"
                    />
                  </div>
                  <div class="custom-link-actions">
                    <button
                      v-show="!load && item.allow_edit"
                      type="button"
                      class="custom-link-action"
                      @click="editItem(item)"
                    >
                      <img src="@/assets/img/icons/editar.svg" />
                      <span>Editar</span>
                    </button>
                    <button
                      v-if="!load"
                      type="button"
                      class="custom-link-action custom-link-action--danger"
                      @click="removeLink(item.id, false)"
                    >
                      <img src="@/assets/img/icons/lixeira.svg" />
                      <span>Excluir</span>
                    </button>
                  </div>
                </b-col>
                <b-col cols="12" md="8">
                  <div class="link-variants">
                    <div class="link-variant">
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Link atual</span>
                        <span class="link-variant__badge">Descontinuado</span>
                      </div>
                      <div class="link-field" :class="{ carregando: load }">
                        <a
                          :href="baseURL + '/redirect/' + item.id"
                          :title="baseURL + '/redirect/' + item.id"
                          target="_blank"
                          class="link-field__value"
                        >{{ displayUrl(baseURL + "/redirect/" + item.id) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button"
                          @click="item.is_alert
                            ? copyAddressWithWarning(baseURL + '/redirect/' + item.id, item.alert_text)
                            : copyAddress(baseURL + '/redirect/' + item.id)"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                    <div v-if="item.tokenized_url" class="link-variant link-variant--recommended">
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Novo link recomendado</span>
                        <span class="link-variant__badge link-variant__badge--recommended">Recomendado</span>
                      </div>
                      <div class="link-field">
                        <a
                          :href="publicCheckoutUrl(item.tokenized_url)"
                          :title="publicCheckoutUrl(item.tokenized_url)"
                          target="_blank"
                          class="link-field__value"
                        >{{ displayCustomUrl(item.tokenized_url) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button link-copy-button--recommended"
                          @click="copyAddress(publicCheckoutUrl(item.tokenized_url))"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </template>
          </template>
        </b-container>
      </b-tab>

      <b-tab title="Afiliado" :active="comingAffiliate">
         <template #title>
          Afiliado
          <span
            v-if="isValidateAccount" 
            id="links-alert-afiliado"
            class="tag-status" 
            :class="'in_progress'"
          >
           {{ $t('views.seller.my_account.status.' + 'in_progress') }}
          </span>
          <b-tooltip
            v-if="isValidateAccount"
            target="links-alert-afiliado"
            title="Para começar a vender acesse ‘Minha Conta’ e finalize seu cadastro."
          />
        </template>
        <b-container class="mt-1 p-5 wrapper container-item">
          <b-row>
            <b-col>
              <h6 class="mb-3">{{ $t("views.seller.links.text_1135") }}</h6>

              <b-form-group label="">
                <div id="affiliate-select">
                  <multiselect
                    v-model="product_id_afiliado"
                    :placeholder="$t('views.seller.links.text_1127')"
                    label="name"
                    :name="`link-${productsAffiliate.id}`"
                    track-by="id"
                    :options="filterAffiliateBy(productsAffiliate)"
                    :multiple="false"
                    :taggable="false"
                    ><span slot="noResult">{{
                      $t("views.seller.links.text_1128")
                    }}</span>
                    <template slot="option" slot-scope="props">
                      <div class="option__desc">
                        <span class="option__title">{{ props.option.name }}</span>
                        <span class="option__desc" v-if="isProductLinkLocked(props.option)"> (Finalize seu cadastro em ‘Minha Conta’)</span>
                      </div>
                    </template>
                  </multiselect>
                </div>
                <b-tooltip
                  v-if="isValidateAccount"
                  target="affiliate-select"
                  title="Para começar a vender acesse ‘Minha Conta’ e finalize seu cadastro."
                />
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="product_id_afiliado">
            <b-row class="mt-4">
              <b-col cols="12">
                <b-form-group :label="$t('views.seller.links.text_1130')">
                  <a
                    v-if="salesPage"
                    :href="salesPage ? salesPage + '/?a_id=' + userID : ''"
                    class="link"
                    target="_blank"
                    :class="{ carregando: load }"
                  >
                    {{
                      cutText(salesPage ? salesPage + "/?a_id=" + userID : "", 100)
                    }}
                  </a>
                  <p v-if="!salesPage" class="p-editado">
                    {{ $t("views.seller.links.text_1131") }}
                  </p>
                  <span
                    v-if="!load && salesPage"
                    @click="copyAddress(salesPage + '/?a_id=' + userID)"
                    class="btn p-2"
                  >
                    <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                  </span>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Link atual do checkout">
                  <a
                    :href="checkoutUrl(product, null, true, 'legacy')"
                    class="link"
                    target="_blank"
                    :class="{ carregando: load }"
                  >
                    {{
                      cutText(checkoutUrl(product, null, true, 'legacy'), 100)
                    }}
                  </a>
                  <span
                    v-if="!load"
                    @click="
                      copyAddress(checkoutUrl(product, null, true, 'legacy'))
                    "
                    class="btn p-2"
                  >
                    <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                  </span>
                </b-form-group>
              </b-col>
              <b-col cols="12" v-if="checkoutUrl(product, null, true, 'tokenized')">
                <b-form-group label="Novo link recomendado do checkout">
                  <a
                    :href="checkoutUrl(product, null, true, 'tokenized')"
                    class="link"
                    target="_blank"
                  >{{ cutText(checkoutUrl(product, null, true, 'tokenized'), 100) }}</a>
                  <span
                    v-if="!load"
                    @click="copyAddress(checkoutUrl(product, null, true, 'tokenized'))"
                    class="btn p-2"
                  >
                    <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                  </span>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="my-2 outros">
              <b-col>
                <h6 class="outros-links">
                  {{ $t("views.seller.links.text_1609") }} 
                </h6>
              </b-col>
            </b-row>
            <template v-for="item in offers">
              <b-row :key="item.id" class="link-extra link-card">
                <b-col cols="12" md="4" class="titulo-link" :title="item.name">
                  {{ cutText(item.name, 65) }}
                </b-col>
                <b-col cols="12" md="8">
                  <div class="link-variants">
                    <div class="link-variant">
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Link atual</span>
                        <span class="link-variant__badge">Descontinuado</span>
                      </div>
                      <div class="link-field" :class="{ carregando: load }">
                        <a
                          :href="checkoutUrl(product, item.hash, true, 'legacy')"
                          :title="checkoutUrl(product, item.hash, true, 'legacy')"
                          target="_blank"
                          class="link-field__value"
                        >{{ displayUrl(checkoutUrl(product, item.hash, true, 'legacy')) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button"
                          @click="copyAddress(checkoutUrl(product, item.hash, true, 'legacy'))"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                    <div
                      v-if="checkoutUrl(product, item.hash, true, 'tokenized')"
                      class="link-variant link-variant--recommended"
                    >
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Novo link recomendado</span>
                        <span class="link-variant__badge link-variant__badge--recommended">Recomendado</span>
                      </div>
                      <div class="link-field">
                        <a
                          :href="checkoutUrl(product, item.hash, true, 'tokenized')"
                          :title="checkoutUrl(product, item.hash, true, 'tokenized')"
                          target="_blank"
                          class="link-field__value"
                        >{{ displayUrl(checkoutUrl(product, item.hash, true, 'tokenized')) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button link-copy-button--recommended"
                          @click="copyAddress(checkoutUrl(product, item.hash, true, 'tokenized'))"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </template>
            <b-row class="my-3 outros">
              <b-col>
                <h6 class="outros-links">
                  {{ $t("views.seller.links.text_1611") }}
                </h6>
              </b-col>
            </b-row>
            <template v-for="item in links">
              <b-row v-if="item.name != 'MAIN'" :key="item.id" class="link-extra link-card">
                <b-col cols="12" md="4" class="titulo-link" :title="item.name">
                  {{ cutText(item.name, 60) }}
                </b-col>
                <b-col cols="12" md="8" class="outro-item">
                  <div class="link-variants">
                    <div class="link-variant">
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Link atual</span>
                        <span class="link-variant__badge">Descontinuado</span>
                      </div>
                      <div class="link-field" :class="{ carregando: load }">
                        <a
                          :href="baseURL + '/redirect/' + item.id + '/?a_id=' + userID"
                          :title="baseURL + '/redirect/' + item.id + '/?a_id=' + userID"
                          class="link-field__value"
                          target="_blank"
                        >{{ displayUrl(baseURL + "/redirect/" + item.id + "/?a_id=" + userID) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button"
                          @click="copyAddress(baseURL + '/redirect/' + item.id + '/?a_id=' + userID)"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                    <div v-if="item.tokenized_url" class="link-variant link-variant--recommended">
                      <div class="link-variant__heading">
                        <span class="link-variant__label">Novo link recomendado</span>
                        <span class="link-variant__badge link-variant__badge--recommended">Recomendado</span>
                      </div>
                      <div class="link-field">
                        <a
                          :href="affiliateUrl(publicCheckoutUrl(item.tokenized_url))"
                          :title="affiliateUrl(publicCheckoutUrl(item.tokenized_url))"
                          class="link-field__value"
                          target="_blank"
                        >{{ affiliateUrl(publicCheckoutUrl(item.tokenized_url)) }}</a>
                        <button
                          v-if="!load"
                          type="button"
                          class="link-copy-button link-copy-button--recommended"
                          @click="copyAddress(affiliateUrl(publicCheckoutUrl(item.tokenized_url)))"
                        >
                          <img src="@/assets/img/icons/copy.svg" class="copy-link" />
                          <span>Copiar</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </template>
            <!-- <b-row v-if="links.length == 1" class="container">
              <p class="link">Nenhum outro link foi encontrado </p>
            </b-row> -->
          </template>
        </b-container>
      </b-tab>
    </b-tabs>

    <NovoLink
      :checkouts="checkouts"
      :isPhysical="isPhysical"
      :product_id="product.id"
      :product_type="product.type"
      :product_name="product.name"
      :product_installments="validItem(product)"
      :productsS="productsSeller"
      :productsA="productsAffiliate"
      :type="comingAffiliate"
      :_cupom="cupom"
      :has_orderbump="has_orderbump"
      :all_edit="dataEdit"
      @close="fetchLinks"
    />
    <!--<CallEvaluation /> -->
  </div>
</template>
<script>
import Vue from "vue";
import Utils from "@/mixins/utils";
import ProductService from "@/services/resources/ProductService";
import CheckoutService from "@/services/resources/CheckoutService";
import AffiliateService from "@/services/resources/AffiliateService";
import LinkService from "@/services/resources/LinkService";
import NovoLink from "@/components/Seller/Links/modals/new";
import { buildCheckoutUrl, rebaseCheckoutUrl } from "@/helpers/checkoutUrl";

const serviceProducts = ProductService.build();
const serviceCheckouts = CheckoutService.build();
const serviceAffiliate = AffiliateService.build();
const serviceLinks = LinkService.build();
import Multiselect from "vue-multiselect";

export default {
  mixins: [Utils],
  components: {
    NovoLink,
    Multiselect,
  },
  data() {
    return {
      dataEdit: null,
      submit: false,
      loading: false,
      comingAffiliate: false,
      has_orderbump: false,
      cupom: null,
      has_cupom: false,
      product_id: null,
      product_id_afiliado: null,
      links: [],
      offers: [],
      products: [],
      product: {
        sales_page: "",
        slug: "",
      },
      productsSeller: [],
      productsAffiliate: [],
      load: true,
      link_afiliado: "---",
      client: {
        width: 0,
      },
      maxLength: 48,
      checkouts: [],
      createLink: false,

    };
  },
  computed: {
    isMobile() {
      if (this.client.width <= 667) this.maxLength = 33;
      return this.client.width <= 768;
    },
    baseURL() {
      return process.env.VUE_SALES_PAGE;
    },
    baseAdmURL() {
      return process.env.VUE_ADM_PAGE;
    },
    salesPage() {
      let r = "";
      for (var i = 0; i < this.links.length; i++) {
        if (this.links[i].url && this.links[i].name == "MAIN") {
          r = this.baseURL + "/redirect/" + this.links[i].id;
        }
      }
      return r;
    },

    isPhysical() {
      return this.product.format === "PHYSICALPRODUCT";
    },
  },
  watch: {
    isMobile(value) {
      if (value) {
        this.maxLength = 33;
      } else this.maxLength = 48;
    },
    product_id() {
      if (!this.has_cupom) {
        this.selectProduct(false);
      } else {
        this.fetchLinks();
        this.fetchOffers();
        this.createLink = true;
        setTimeout(() => {
          this.load = false;
          this.has_cupom = false;
        }, 500);
      }
    },
    product_id_afiliado() {
      this.selectProduct(true);
    },
  },
  methods: {
    checkoutUrl(product, offerHash = null, affiliate = false, identifier = "tokenized") {
      return buildCheckoutUrl(this.baseURL, product, {
        offerHash,
        identifier,
        query: affiliate ? { a_id: this.userID } : {},
      });
    },
    affiliateUrl(url) {
      if (!url) return "";
      const separator = url.includes("?") ? "&" : "?";
      return `${url}${separator}a_id=${this.userID}`;
    },
    filterBy(data) {
      return data.filter((data) => {
        // KYC pendente: só produtos de Pós-Graduação ficam selecionáveis
        if (
          data.status !== 'APPROVED' || this.isProductLinkLocked(data)
        ) {
          return (data.$isDisabled = true);
        } else {
          delete data.$isDisabled;
          return data;
        }
      });
    },
    filterAffiliateBy(data) {
      // KYC pendente: só afiliações de produtos de Pós-Graduação ficam selecionáveis
      return data.filter((item) => {
        if (this.isProductLinkLocked(item)) {
          return (item.$isDisabled = true);
        }
        delete item.$isDisabled;
        return item;
      });
    },
    validItem(product) {
      // if(product.max_boleto_installments !== undefined && product.max_boleto_installments !== 0 && product.max_boleto_installments !== null || product.format === "PHYSICALPRODUCT"){
      //   return false;
      // }
      return true;
    },
    getParameterByName(name, url) {
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    },
    editItem(item) {
      this.fetchSellerProducts2();
      item.bump_id = this.getParameterByName("b_id", item.url);

      let bumpIds = [];
      let bumpOffers = [];

      const params = new URLSearchParams(new URL(item.url).search);

      params.forEach((value, key) => {
        if (key.startsWith("b_id")) {
            bumpIds.push(parseInt(value));
        }
        if (key.startsWith("b_offer")) {
            bumpOffers.push(value);
        }
      });

      var myArray = this.productsSeller;
      item.product_order_b = [];

      bumpIds.forEach((bump_id, index) => {
        let filter = myArray.filter((x) => x.id === bump_id);
        item.product_order_b.push({
            bump_id: bump_id,
            bump_offer: bumpOffers[index] || null,
            product: filter
        });
      });

      this.dataEdit = item;
      this.$bvModal.show("links-new");
    },
    setProduct(reset, produtor = false) {
      if (!produtor) {
        if (this.$route.query.affiliation_id && !reset) {
          this.product_id_afiliado = {
            id: +this.$route.query.affiliation_id,
            name: this.$route.query.p_name,
          };
        } else if (reset) {
          this.product_id_afiliado = null;
        }
      } else {
        this.product_id = {
          id: +this.$route.query.p_id,
          name: this.$route.query.p_name,
          type: this.$route.query.p_type,
        };

        if (this.has_orderbump) {
          this.$bvModal.show("links-new");
          if (this.product_id.type == "SUBSCRIPTION") {
            this.$bvToast.toast(
              `${this.$t("views.seller.links.text_1613")} ${
                this.product_id.name
              } ${this.$t("views.seller.links.text_1136")}`,
              {
                title: "Link",
                variant: "info",
                autoHideDelay: 5000,
                appendToast: true,
              }
            );
          }
        }
      }
    },
    cutText(text, maxLength = null) {
      maxLength = maxLength || this.maxLength;
      if (text) {
        return text.length > maxLength
          ? text.substr(0, maxLength) + "..."
          : text;
      } 
      return text;
    },
    displayUrl(url) {
      return url || "";
    },
    displayCustomUrl(url) {
      return this.publicCheckoutUrl(url);
    },
    publicCheckoutUrl(url) {
      return rebaseCheckoutUrl(this.baseURL, url);
    },
    handleResize() {
      // this.client.width = window.innerWidth;
      this.client.width = window.innerWidth;
    },
    affiliateLink() {
      if (this.product.id) {
        let data = {
          product_id: this.product.id,
          url: "invite",
        };

        serviceAffiliate
          .search(data)
          .then((response) => {
            this.link_afiliado = `${process.env.VUE_ADM_PAGE}/recrutamento/${response.hash}/?p_id=${this.product.id}`;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },

    removeLink(id, affiliate) {
      Vue.swal({
        title: this.$t("views.seller.links.text_1138"),
        text: this.$t("views.seller.links.text_1139"),
        type: "danger",
        showCancelButton: true,
        confirmButtonText: this.$t("views.seller.links.text_1138"),
        cancelButtonText: this.$t("views.seller.links.text_1614"),
        customClass: "sweet-container",
        confirmButtonClass: "button button-danger mt-3 mb-3",
        cancelButtonClass: "button button-link-info mr-4 mt-3 mb-3",
        buttonsStyling: false,
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let data = {
            id: id,
          };

          serviceLinks.destroy(data).then(() => {
            if (affiliate) {
              this.selectProduct(true);
            } else this.selectProduct(false);

            this.$bvToast.toast(this.$t("views.seller.links.text_1142"), {
              title: "Link",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
          });
        }
      });
    },

    copyAddress(link) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$bvToast.toast(this.$t("views.seller.links.text_1615"), {
        title: this.$t("views.seller.links.text_1616"),
        variant: "success",
        autoHideDelay: 5000,
        appendToast: true,
      });
    },

    copyAddressWithWarning(link, message) {
      const el = document.createElement("textarea");
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);

      this.$bvToast.toast(message, {
        title: this.$t("views.seller.links.text_1616"),
        variant: "warning",
        autoHideDelay: 5000,
        appendToast: true,
      });
    },

    selectProduct(affiliate) {
      this.load = true;
      if (this.product_id) {
        let product = [...this.products].find((item) => {
          if (item.id == this.product_id.id) {
            return item;
          }
        });
        // if (affiliate) this.product = product.;
        // else this.product = product[0];
        this.product = product;
      }
      if (affiliate) {
        if (this.product_id_afiliado) {
          let product = [...this.products].find((item) => {
            if (item.id == this.product_id_afiliado.id) {
              return item;
            }
          });
          this.product = product.product || product;
        }
      }
      this.fetchLinks();
      this.fetchOffers();
      this.verifyAfilliate();
      setTimeout(() => {
        this.load = false;
      }, 500);
    },
    verifyAfilliate() {
      if (this.userID === this.product.seller_id) {
        this.createLink = true;
      } else {
        this.createLink = false;
      }
    },
    tabSelect(newTabIndex) {
      this.product_id = null;
      this.product_id_afiliado = null;
      this.link_afiliado = "---";
      switch (newTabIndex) {
        case 0: {
          this.comingAffiliate = false;
          this.fetchSellerProducts();
          break;
        }
        case 1: {
          this.comingAffiliate = true;
          this.fetchAffiliateProducts();
          break;
        }
      }
    },
    fetchLinks() {
      let data = {
        product_id: this.product.id,
      };

      if (!this.product.id) {
        return;
      }

      serviceLinks.search(data).then((response) => {
        if (Array.isArray(response) && response.length) {
          this.links = response.map((link) => {
            link.is_alert = false;
            link.allow_edit = true;
            link.alert_type = null;
            link.alert_text = null;

            if (
              link.offer_select === null
            ) {
              link.is_alert = true;
              link.alert_type = "danger";
              link.alert_text = `Link inativo. Edite e adicione uma oferta para reativar.`;

              return link;
            }

            if (
              link.offer_select &&
              link.offer_select.status_offer !== "APPROVED"
            ) {
              link.is_alert = true;
              link.alert_type = "warning";
              link.alert_text = `O link ativará automaticamente após análise da oferta: ${link.offer_select.name}`;

              return link;
            }

            if (link.is_bump) {
              if (link.bump_select && link.bump_select) {
                const product = link.bump_select;

                if (product.is_active === 0) {
                  link.is_alert = true;
                  link.allow_edit = false;
                  link.alert_type = "danger";
                  link.alert_text = `Order bump desativado, produto: ${product.name}`;

                  return link;
                }

                if (
                  product.status !== "APPROVED" ||
                  product.status_product !== "APPROVED"
                ) {
                  link.is_alert = true;
                  link.allow_edit = true;
                  link.alert_type = "warning";
                  link.alert_text = `O link ativará automaticamente após análise do produto: ${product.name}`;

                  return link;
                }
              }

              if (
                link.offer_bump_select &&
                link.offer_bump_select.status_offer !== "APPROVED"
              ) {
                link.is_alert = true;
                link.alert_type = "danger";
                link.allow_edit = false;
                link.alert_text = `A oferta não aprovada! Oferta: ${link.offer_bump_select.name}`;

                return link;
              }
            }

            return link;
          });
        }
      });
    },
    fetchOffers() {
      if (this.product.id) {
        let data = {
          id: this.product.id + "/offers",
        };
        serviceProducts.read(data).then((response) => {
          this.offers = response;
        });
      }
    },
    fetchSellerProducts2() {
      let data = {
        list: true,
      };

      serviceProducts
        .search(data)
        .then((response) => {
          this.productsSeller = [];
          response.forEach((element) => {
            this.productsSeller.push({
              id: element.id,
              name: element.name,
              type: element.type,
              max_boleto_installments: element.max_boleto_installments,
              format: element.format,
              offers: element.offers,
              status: element.status,
              checkout_hash: element.checkout_hash,
            });
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchSellerProducts() {
      this.loading = true;
      this.index = null;
      this.product = {
        sales_page: "",
        slug: "",
      };
      this.links = [];
      this.productsAffiliate = [];

      let data = {
        list: true,
      };

      serviceProducts
        .search(data)
        .then((response) => {
          this.productsSeller = [];
          this.products = response;

          this.products.forEach((element) => {
            this.productsSeller.push({
              id: element.id,
              name: element.name,
              type: element.type,
              max_boleto_installments: element.max_boleto_installments,
              format: element.format,
              offers: element.offers,
              status: element.status,
              checkout_hash: element.checkout_hash,
            });
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchAffiliateProducts() {
      this.loading = true;

      this.index = null;
      this.product = {
        sales_page: "",
        slug: "",
      };
      this.links = [];
      this.productsSeller = [];

      serviceAffiliate
        .search({ per_page: 500 })
        .then((response) => {
          this.products = response.data;
          this.productsAffiliate = [];
          this.products.forEach((element) => {
            this.productsAffiliate.push({
              id: element.id,
              name: element.product.name,
              type: element.type,
              format: element.product.format,
              checkout_hash: element.product.checkout_hash,
            });
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fetchCheckouts() {
      serviceCheckouts.search().then((response) => {
        this.checkouts = response;
      });
    },
  },

  mounted() {
    this.fetchSellerProducts();
    this.fetchCheckouts();

    // if (typeof this.$route.query.affiliation_id != "undefined") {
    //   this.tabSelect(1);
    //   setTimeout(() => {
    //     if (this.$route.query.affiliation_id) {
    //       this.setProduct();
    //     }
    //   }, 1000);
    // }

    // if (typeof this.$route.query.comingAffiliate != "undefined") {
    //   this.$bvToast.toast("Veja os links de divulgação", {
    //     title: "Afiliação",
    //     variant: "info",
    //     autoHideDelay: 5000,
    //     appendToast: true,
    //   });
    // }

    // if (typeof this.$route.query.orderbump != "undefined") {
    //   this.has_orderbump = true;
    //   this.tabSelect(0);
    //   setTimeout(() => {
    //     if (this.$route.query.p_id) {
    //       this.setProduct(false, true);
    //     }
    //   }, 1000);

    //   this.$bvToast.toast(
    //     "Para criar um Order Bump, selecione um produto e clique em 'Adicionar um link'",
    //     {
    //       title: "Order Bump",
    //       variant: "info",
    //       autoHideDelay: 5000,
    //       appendToast: true,
    //     }
    //   );
    // }

    // cupom
    if (typeof this.$route.query.c_id != "undefined") {
      this.setProduct("", true);
      const query = this.$route.query;

      this.has_cupom = true;

      this.cupom = {
        id: +query.c_id,
        name: query.c_name,
      };

      this.product = {
        id: +query.p_id,
        name: query.p_name,
        type: query.p_type,
      };

      this.$bvModal.show("links-new");
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped>

.multiselect__option--disabled span {
  color: #ccc;

}
.order-bump-alert {
  display: inline;
  width: 18px;
  max-width: 100%;
  display: inline;
  margin-bottom: 7px;
  margin-left: 2px;
}

.link {
  font-size: 14px;
  color: #81858e;
  font-weight: normal;
  border-radius: 5px;
  width: 100%;
}
.copy-link {
  width: 15px;
  /* margin-left: 20px; */
  filter: invert(50%);
  cursor: pointer;
  transition: 0.3s ease;
}
.copy-link:hover {
  filter: invert(0);
}
.link-card {
  align-items: flex-start;
  padding: 18px 0;
  border-bottom: 1px solid #edf0f5;
}
.link-variants {
  display: grid;
  gap: 12px;
  min-width: 0;
}
.link-variant {
  min-width: 0;
}
.link-variant--recommended {
  padding: 12px;
  border: 1px solid #c7d9f5;
  border-radius: 10px;
  background: #f4f8ff;
}
.link-variant__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 7px;
}
.link-variant__label {
  color: #667085;
  font-size: 12px;
  font-weight: 600;
}
.link-variant--recommended .link-variant__label {
  color: #174ea6;
}
.link-variant__badge {
  flex: none;
  padding: 2px 7px;
  border-radius: 12px;
  background: #f2f4f7;
  color: #667085;
  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
}
.link-variant__badge--recommended {
  background: #dbeafe;
  color: #174ea6;
}
.link-field {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}
.link-field__value {
  display: block;
  flex: 1;
  min-width: 0;
  padding: 10px 12px;
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  background: #f8f9fb;
  color: #475467;
  font-size: 13px;
  line-height: 20px;
  overflow-wrap: anywhere;
  text-align: left;
  white-space: normal;
}
.link-field__value:hover {
  border-color: #c9d2df;
  color: #174ea6;
  text-decoration: none;
}
.link-variant--recommended .link-field__value {
  border-color: #d7e2f3;
  background: #fff;
}
.link-copy-button {
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 42px;
  padding: 0 13px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #475467;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  transition: border-color 0.2s ease, background 0.2s ease;
}
.link-copy-button:hover {
  border-color: #98a2b3;
  background: #f9fafb;
}
.link-copy-button--recommended {
  border-color: #174ea6;
  background: #174ea6;
  color: #fff;
}
.link-copy-button--recommended:hover {
  border-color: #103c82;
  background: #103c82;
}
.link-copy-button--recommended .copy-link {
  filter: brightness(0) invert(1);
}
.link-copy-button--recommended span {
  color: #fff;
}
.custom-link-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}
.custom-link-action {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 8px;
  border: 0;
  border-radius: 6px;
  background: #f2f4f7;
  color: #475467;
  cursor: pointer;
  font-size: 11px;
  font-weight: 600;
}
.custom-link-action:hover {
  background: #e8ecf1;
}
.custom-link-action img {
  width: 13px;
  opacity: 0.65;
}
.custom-link-action--danger {
  color: #b42318;
}
.carregando {
  background: rgba(0, 0, 0, 0.03);
  color: transparent;
}
h6 {
  font-weight: 600;
  color: #002363;
}
.outros {
  padding-top: 30px;
  border-top: 1px solid #ededf079;
}
.outros-links {
  color: #333;
  font-size: 16px;
}
.wrapper {
  margin-top: -20px !important;
  z-index: 2;
}
.outro-item {
  margin-bottom: 7px;
}
.campanha_nome {
  margin: 0;
  color: #333;
  font-size: 14px;
  font-weight: 600;
  margin-right: 10px;
}
.sub-titulo {
  font-weight: 600;
  color: #81858e;
  font-size: 14px;
}
.titulo-link {
  font-weight: 600;
  font-size: 14px;
}
.container-item {
  padding: 50px !important;
}
@media screen and (max-width: 768px) {
  .container {
    padding: 0;
  }
  .wrapper {
    padding: 30px 20px !important;
  }
  .container-item {
    padding: 30px !important;
    margin-bottom: 20px;
  }
  .tabs {
    margin: 40px 0 !important;
  }
  h6 {
    font-size: 15px;
  }
  .btn-adicionar {
    width: 100%;
    margin-top: -30px;
    margin-bottom: 10px;
  }

  .link-extra + .link-extra {
    margin-top: 15px;
  }
  .link-card {
    padding: 16px 0;
  }
  .link-card .titulo-link {
    margin-bottom: 12px;
  }
  .link-field {
    align-items: stretch;
  }
  .link-copy-button {
    min-height: 40px;
    padding: 0 10px;
  }
}
.p-editado {
  font-size: 14px;
  color: #81858e;
}

.tag-status {
  border-radius: 16px;
  padding: 1px 4px 1px 5px;
  align-items: flex-start;
  font-size: 10px;
  font-weight: 500;
  line-height: 18px;
  margin-left: 5px;
}

.tag-status.pending {
  border: 1px solid #DC2626;
  color: #DC2626;
  background: #FEF2F2;
}

.tag-status.in_progress {
  border: 1px solid #D97706;
  color: #D97706;
  background: #FFFBEB;
}

.tag-status.rejected {
  border: 1px solid #DC2626;
  color: #DC2626;
  background: #FEF2F2;
}

.tag-status.approved {
  border: 1px solid #059669;
  color: #059669;
  background: #ECFDF5;
}
</style>
